import { Routes } from '@angular/router';
import { BlankComponent } from 'src/app/template/layouts/blank/blank.component';
import { FullComponent } from 'src/app/template/layouts/full/full.component';

export const FullLayoutRoutes: Routes = [
  {
    path: '',
    component: FullComponent,
    children: [
      {
        path: '',
        redirectTo: 'dashboards',
        pathMatch: 'full'
      },
      {
        path: 'dashboards',
        loadChildren: () => import('../../dashboards/dashboards.routes').then((m) => m.DashboardsRoutes)
      },
      {
        path: 'forms',
        loadChildren: () => import('../../forms/forms.routes').then((m) => m.FormsRoutes)
      },
      {
        path: 'charts',
        loadChildren: () => import('../../charts/charts.routes').then((m) => m.ChartsRoutes)
      },
      {
        path: 'apps',
        loadChildren: () => import('../../apps/apps.routes').then((m) => m.AppsRoutes)
      },
      {
        path: 'widgets',
        loadChildren: () => import('../../widgets/widgets.routes').then((m) => m.WidgetsRoutes)
      },
      {
        path: 'tables',
        loadChildren: () => import('../../tables/tables.routes').then((m) => m.TablesRoutes)
      },
      {
        path: 'datatable',
        loadChildren: () => import('../../datatable/datatable.routes').then((m) => m.DatatablesRoutes)
      },
      {
        path: 'theme-pages',
        loadChildren: () => import('../../theme-pages/theme-pages.routes').then((m) => m.ThemePagesRoutes)
      },
      {
        path: 'ui-components',
        loadChildren: () => import('../../ui-components/ui-components.routes').then((m) => m.UiComponentsRoutes)
      }
    ]
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: 'authentication',
        loadChildren: () => import('../../authentication/authentication.routes').then((m) => m.AuthenticationRoutes)
      },
      {
        path: 'landingpage',
        loadChildren: () => import('../../theme-pages/landingpage/landingpage.routes').then((m) => m.LandingPageRoutes)
      },
      {
        path: 'front-pages',
        loadChildren: () => import('../../front-pages/front-pages.routes').then((m) => m.FrontPagesRoutes)
      }
    ]
  }
];
